<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Live Chats</h1>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div data-sidebar-container="chat" class="card chat-sidebar-container">
      <chat-list-component
        :tb_type="$route.params.tb_type"
        @conversationSelected="conversationSelected"
      />
      <chat-content-component :conversation="conversation" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ChatListComponent from "@/views/contents/chat/chat-list.vue";
import ChatContentComponent from "@/views/contents/chat/chat-content.vue";

export default {
  name: "chat",
  data() {
    return {
      conversation: null
    };
  },
  components: {
    ChatListComponent,
    ChatContentComponent
  },
  methods: {
    conversationSelected(conversation) {
      this.conversation = conversation;
    }
  }
};
</script>
